import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { HomeComponent } from './home.component';
import { Shell } from '@app/shell/shell.service';
import { ClientResolverService } from '@app/core/client-resolver.service';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'client/:clientId/dashboard',
      component: HomeComponent,
      data: {
        title: 'Dashboard'
      },
      resolve: {
        client: ClientResolverService
      }
    }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class HomeRoutingModule {}
